import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../hooks/hooks';
import TenantWebsitesComponent from '../components/tenant-website.component';
import { tenantWebsites } from '../../../../redux/tenant-websites/action';
import { tenantWebsiteCards } from '../../../../redux/tenant-website-cards/action';
import { useSelector } from 'react-redux';
import { selectTenantWebsiteCardsListItems } from '../../../../redux/tenant-website-cards/selector';
import { websites } from '../../../../redux/websites/action';
import { selectWebsiteListItems } from '../../../../redux/websites/selector';
import { selectListItems } from '../../../../redux/stores/selector';
import { stores } from '../../../../redux/stores/action';
import { selectDepartmentsListItems } from '../../../../redux/departments/selector';
import { departments } from '../../../../redux/departments/action';
import { formatWebsiteListData } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';



const TenantWebsite= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {tenantId,id} = useParams()
  const orderItems = useSelector(selectTenantWebsiteCardsListItems)
  const websitesLists = useSelector(selectWebsiteListItems)
  const storeLists = useSelector(selectListItems)
  const departmentLists = useSelector(selectDepartmentsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true) 
  const [
    selectedTenantWebsites,
    setSelectedTenantWebsites
  ] = useState<any>([])
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTenantWebsites({ ...selectedTenantWebsites, [field]: event });
  }

  useEffect(
    () => {
     
      dispatch(tenantWebsiteCards.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,entity:'tenantWebsiteCards',jsonData:{
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": tenantId,
            "FieldType": "number"
          },
          {
              "FieldName": "PlatformWebSiteId",
              "FieldType": "number",
              "FilterOperatorId": 1,
              "FieldValue": id
          }
        ],
      }}))

     
    },
    []
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    await dispatch(tenantWebsiteCards.resetAction({ actionType: 'create' }))
await dispatch(tenantWebsiteCards.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`,entity:'tenantWebsiteCards',jsonData:{       
  Records: [
  {
    Context: {},
    Message: {
  TenantId: Number(tenantId),
  StoreId: selectedTenantWebsites?.StoreId,
  DepartmentId: selectedTenantWebsites?.DepartmentId,
  PlatformWebSiteId: selectedTenantWebsites?.PlatformWebSiteId,
  WebSiteName: selectedTenantWebsites?.WebSiteName,
  Remarks: selectedTenantWebsites?.Remarks,
  HostingUrl: selectedTenantWebsites?.HostingUrl,
  MappedDomain: selectedTenantWebsites?.MappedDomain,
  DisplayOrder: selectedTenantWebsites?.DisplayOrder
    }
}
]

}}))

.then(() => {
    back()
})
  }

const back=()=>{
    navigate(`/web-platform/platform-management/tenants/${tenantId}`)
} 
const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'WebsiteName', headerName: 'WebsiteName' , sortable: true, filter: true},
      { field: 'CardName', headerName: 'CardName' },
      { field: 'PageName', headerName: 'PageName'},
      { field: 'LayoutName', headerName: 'LayoutName'},
  
    ]);
  }

  useEffect(
    () => {
        dispatch(websites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/list`,entity:'websites',jsonData:{}})).then(()=>{
        dispatch(stores.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/stores/list`,
        entity:'stores',
        jsonData:{
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ]
        }})).then(()=>{
        dispatch(departments.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/departments/list`,entity:'departments',jsonData:{
          
            Records: [
              {
                Id: tenantId
          
              }
            ]
          
        }}))
      })
    })
        if (Number(id) > 0) {
        createColumnDefs()
        setIsLoading(false)
        dispatch(tenantWebsiteCards.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
            entity: 'tenantWebsiteCards',
            jsonData: {
                "Filters": [
                    {
                      "FieldName": "TenantId",
                      "FilterOperatorId": 1,
                      "FieldValue": tenantId,
                      "FieldType": "number"
                    },
                    {
                        "FieldName": "PlatformWebSiteId",
                        "FieldType": "number",
                        "FilterOperatorId": 1,
                        "FieldValue": id
                    }
                  ],
            }
        }))
      }
      else{
        setIsLoading(false)
      }
    },
    []
  )
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
   
   }
   const handleDelete=(data: any)=>{
    dispatch(tenantWebsiteCards.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/delete`,
      entity: 'tenantWebsiteCards',
      jsonData: {
        Records: [
              {
                "Context":{},
                "Message":{CardId: data?.Id}
                  
              }
          ]
      }
  })).then(() => {
    dispatch(tenantWebsiteCards.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
        entity: 'tenantWebsiteCards',
        jsonData: {
            "Filters": [
                {
                  "FieldName": "TenantId",
                  "FilterOperatorId": 1,
                  "FieldValue": tenantId,
                  "FieldType": "number"
                },
                {
                    "FieldName": "PlatformWebSiteId",
                    "FieldType": "number",
                    "FilterOperatorId": 1,
                    "FieldValue": id
                }
              ],
        }
    }))
});
const handleAdd=()=>{
  navigate(`${0}`)
}
  }
  const additionButtons: any = [
    {
      name: 'Back To Tenant Website',
      callback: () => back(),
    }
  ];
    return (
    <>
       {isLoading ? <PageLoader /> : 
          <TenantWebsitesComponent 
            selectedTenantWebsites={selectedTenantWebsites}
            handleInnerFormChange={handleInnerFormChange}
            websites={formatWebsiteListData(websitesLists?.result?.items)}
            back={back}
            handleFormSubmit={handleFormSubmit}
            onDelete={handleDelete}
            onEdit={handleEdit}
            rowData={orderItems?.result?.items}
            columnDefs={columnDefs}
            Id={id}
            additionButtons={additionButtons}
            stores={storeLists?.result?.items}
            departments={departmentLists?.result?.items}
          />  
    }
          </>
    )
    
    }
   
    export default TenantWebsite;